module.exports = __webpack_public_path__ + "img/partner1.214f684c.png";